import { useContext } from 'react';
import { UserContext, type UserContextValue } from '../state/UserContext';

export function useUser(): UserContextValue {
  return useContext(UserContext);
}
